<template>
    <div>
        <div class="content-caption dashed">
            <span>基本信息</span>
        </div>
        <div class="simple-form flex col-4">
            <div class="form-group">
                <div class="form-label">
                    <label>买家名称</label>
                </div>
                <div class="form-value">
                    <span>{{ receiptList[0].buyerName || '' }}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>卖家名称</label>
                </div>
                <div class="form-value">
                    <span>{{ receiptList[0].sellerName || '' }}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>供应商标识</label>
                </div>
                <div class="form-value">
                    <span>{{ receiptList[0].buyerInnerSellerCode || '' }}</span>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label>利润中心</label>
                </div>
                <div class="form-value">
                    <span>{{ receiptList[0].prftCenterCode || '' }}</span>
                </div>
            </div>
        </div>
        <div class="simple-form flex col-2">
            <div class="form-group">
                <div class="form-label">
                    <label>结算描述</label>
                </div>
                <div class="form-value">
                    <textarea v-model="memo" style="width: 320px;height: 90px"></textarea>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>验收单信息</span>
            <div class="fr font12">
                <span>结算金额：{{ totalWtxAmount || 0.00 }}元</span>
            </div>
        </div>
        <div class="table-layout">
            <el-table :data="receiptList" ref="multipleTable" border>
                <el-table-column align="left" prop="recvBizUnitName" label="业务单元" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="recvBizUnitCode" label="门店编号" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="innerNo" label="验收单号" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="recvDate" width="160" :label="returnFalg? '退货日期': '验收日期'"></el-table-column>
                <el-table-column align="right" prop="receiptQuantity" width="160" label="验收数量"></el-table-column>
                <el-table-column align="right" prop="wtxAmount" width="160" label="结算金额(元)"></el-table-column>
                <el-table-column prop="ntxPrice" align="left" label="操作">
                    <template slot-scope="rows">
                        <span class="swb-btn swb-btn-link" @click="viewPurchReceipt(rows.row.id)">验收详情</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <template v-if="phasedPaymentAllowed">
            <div class="content-caption dashed">
                <span>付款阶段</span>
            </div>
            <div class="simple-form flex col-2">
                <div class="form-group">
                    <div class="form-label">
                        <label>付款账期形式</label>
                    </div>
                    <div class="form-value">
                        <el-radio-group v-model="settlePayPhaseInfo.acntPeriodForm">
                            <el-radio :label="2" v-if="payPeriodTypesAllowed.indexOf(2) > -1">阶段间隔天数</el-radio>
                            <el-radio :label="1" v-if="payPeriodTypesAllowed.indexOf(1) > -1">账期</el-radio>
                        </el-radio-group>
                    </div>
                </div>
            </div>
            <el-form :model="settlePayPhaseInfo" ref="ruleForm">
                <table class="custom-tbl error-prompt">
                    <thead class="head">
                    <tr class="row">
                        <th class="text-align: left; required">阶段名称</th>
                        <th width="200" class="text-align: left; required">阶段类型</th>
                        <th width="200" class="text-align: right; required">账期起算日</th>
                        <th width="100" class="text-align: right; required" v-if="settlePayPhaseInfo.acntPeriodForm == 1">账期(天)</th>
                        <th width="140" class="text-align: right; required" v-if="settlePayPhaseInfo.acntPeriodForm == 2">当期阶段间隔天数</th>
                        <th width="200" class="text-align: left; required">金额计算依据</th>
                        <th width="120" class="text-align: left; required">付款比例(%)</th>
                        <th width="120" class="text-align: left;">付款金额</th>
                        <th width="150" class="text-align: right; required">支付方式</th>
                        <th width="100">操作</th>
                    </tr>
                    </thead>
                    <tbody class="body">
                    <tr v-for="(item,index) in settlePayPhaseInfo.settlePayPhaseList" class="row">
                        <td :rowspan="item.rowspan" v-if="item.visible">
                            <el-form-item :prop="'settlePayPhaseList.' + index + '.phaseName'" :rules="{validator: checkPhaseName, trigger: 'blur'}">
                                <el-input class="fl" style="width: 80%;" type="text" v-model="item.phaseName" @blur="changePhaseName(index)"></el-input>
                                <a class="swb-btn-link fr inline-block" @click="addPhaseItem(index)" v-if="item.rowspan < payMethodList.length">增加付款次数</a>
                            </el-form-item>
                        </td>
                        <td :rowspan="item.rowspan" v-if="item.visible">
                            <el-form-item>
                                <el-select v-model="item.phaseType" @change="changePhaseType(index)">
                                    <el-option v-for="item in phaseTypeList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </td>
                        <td :rowspan="item.rowspan" v-if="item.visible"><!-- 折旧起算日 calcBasis -->
                            <el-form-item :prop="'settlePayPhaseList.' + index + '.acntPeriodStartDate'" :rules="{required: true, type : 'date', message: '请选择日期', trigger: 'change'}">
                                <el-date-picker style="width: 120px;" v-model="item.acntPeriodStartDate" type="date" format="yyyy-MM-dd" placeholder="选择日期" @change="changeAcntPeriodStartDate(index)"></el-date-picker>
                            </el-form-item>
                        </td>
                        <td class="text-right" :rowspan="item.rowspan" v-if="settlePayPhaseInfo.acntPeriodForm == 1 && item.visible"><!-- 账期(天) acntPeriodDays -->
                            <el-form-item :prop="'settlePayPhaseList.' + index + '.acntPeriodDays'" :rules="{validator : validateIntNotNull, trigger: 'blur'}">
                                <el-input v-model.number="item.acntPeriodDays" @change="changeAcntPeriodDays(index)"></el-input>
                            </el-form-item>
                        </td>
                        <td class="text-right" :rowspan="item.rowspan" v-if="settlePayPhaseInfo.acntPeriodForm == 2 && item.visible"> <!-- 当期阶段间隔天数 phaseGapDays -->
                            <el-form-item :prop="'settlePayPhaseList.' + index + '.phaseGapDays'" :rules="{validator : validateIntNotNull, trigger: 'blur'}">
                                <el-input v-model.number="item.phaseGapDays" @change="changePhaseGapDays(index)"></el-input>
                            </el-form-item>
                        </td>
                        <td><!-- 金额计算依据 calcBasis -->
                            <el-form-item>
                                <el-select v-model="item.calcBasis">
                                    <el-option v-for="item in amtCalcMethodList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </td>
                        <td class="text-right">
                            <el-form-item :prop="'settlePayPhaseList.' + index + '.ratio'" :rules="{validator: validateRatio, trigger: 'blur'}">
                                <el-input v-model="item.ratio" @blur="changeRatio(index)"></el-input>
                            </el-form-item>
                        </td>
                        <td class="text-right">
                            <span>{{ item.amount }}</span>
                        </td>
                        <td><!-- 支付方式 payMethod -->
                            <el-form-item>
                                <el-select v-model="item.payMethod">
                                    <el-option v-for="item in payMethodList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </td>
                        <td>
                            <div @click="payPhaseRemoveItem(index);" class="swb-btn swb-btn-link">
                                <span>移除</span>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                    <tfoot class="foot"
                           v-if="settlePayPhaseInfo.settlePayPhaseList[settlePayPhaseInfo.settlePayPhaseList.length - 1] == null || settlePayPhaseInfo.settlePayPhaseList[settlePayPhaseInfo.settlePayPhaseList.length - 1].phaseType != 9">
                    <tr class="row">
                        <td colspan="9" style="padding: 10px; border: 1px solid #dfe6ec; text-align: center;">
                            <div @click="addSettlePayPhase();" class="swb-btn swb-btn-link">
                                <i class="icon iconfont icon-jiahao mr5"></i>
                                <span>添加阶段</span>
                            </div>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </el-form>
        </template>
    </div>
</template>

<script>
import {Utils} from '../../app.base'
import {Vue, MsgBox, Routes} from '../../app.vues'
import {openPurchReceiptTmpDetailDlg} from './showDlg'

import vendorApi from '../../api/vendor';
import receiptApi from '../../api/receipt';
import {getRealCtrlParam} from "../asset/assetMain";

export default {
    name: 'swb-purch-receipt-settle-proof-tmp-save',
    desc: '临采验收单-结算',
    props: ['purchReceiptList', 'returnFalg'],  // returnFalg: 是否退货验收
    data: function () {
        return {
            receiptList: [],
            totalWtxAmount: 0.00,
            totalSettlePrice: 0,
            autoApply: false,
            autoAudit: false,
            memo: null, // 结算描述
            settlePayPhaseInfo: {
                acntPeriodForm: 2, // 付款账期形式
                settlePayPhaseList: [] // 付款阶段
            },
            phasedPaymentAllowed: true,
            payPeriodTypesAllowed: [2],
            payPeriodTypeMap: getEnumMap('payPeriodType', 'value2text'),
            payPhaseTypeMap: getEnumMap('payPhaseType', 'value2text'),
            amtCalcMethodMap: getEnumMap('amtCalcMethod', 'value2text'),
            payMethodMap: getEnumMap('payMethod', 'value2text'),
            phaseTypeList: getEnumList('payPhaseType') || [],
            payMethodList: getEnumList('payMethod') || [],
            amtCalcMethodList: []
        }
    },
    created: function () {
        let self = this;
        let purchReceiptList = this.purchReceiptList || [];
        if (Utils.isNoB(purchReceiptList) || purchReceiptList.length <= 0) {
            MsgBox.warning('参数异常！');
            return false;
        }
        let purchReceiptIds = purchReceiptList.pluck('id');
        this.getpurchReceiptDetail(purchReceiptIds);
        //
        // 金额计算依据
        let amtCalcMethodList = [];
        let amtCalcMethods = getEnumList('amtCalcMethod') || [];
        let amtCalcMethodByAmount = getEnumInfoWith('amtCalcMethod', 'name', 'ByAmount');
        for (let i = 0; i < amtCalcMethods.length; i++) {
            let amtCalcMethod = amtCalcMethods[i];
            if (amtCalcMethod.name != amtCalcMethodByAmount.name) {
                amtCalcMethodList.push(amtCalcMethod);
            }
        }
        this.amtCalcMethodList = Utils.merge([], amtCalcMethodList);

        getRealCtrlParam('tmppurch.settle.phased.payment.allowed', function (result) {
            self.phasedPaymentAllowed = Utils.isTrue(result);
        });
        getRealCtrlParam('tmppurch.allowed.pay.period.types', function (result) {
            self.payPeriodTypesAllowed = result;
            if (self.payPeriodTypesAllowed.indexOf(2) == -1) {
                self.settlePayPhaseInfo.acntPeriodForm = self.payPeriodTypesAllowed[0];
            }
        });
    },
    methods: {
        // 查看购置验收单详情
        getpurchReceiptDetail: function (purchReceiptIds) {
            let msgBoxDlg = MsgBox.loading();
            receiptApi.getPurchReceiptListByIds(purchReceiptIds, (result) => {
                msgBoxDlg.close();
                if (result.type == 'info') {
                    let purchReceipts = result.data || [];
                    let totalWtxAmount = 0;
                    for (let i = 0; i < purchReceipts.length; i++) {
                        let purchReceipt = purchReceipts[i];
                        // 临采前段显示：结算费用 - 重新汇总明细项的总金额，包含已分摊的费用。原总金额不包含分摊的费用
                        let itemList = purchReceipt.itemList || [];
                        let amount = 0;
                        let receiptQuantity = 0;
                        for (let i = 0; i < itemList.length; i++) {
                            let item = itemList[i];
                            amount += parseFloat(item.wtxAmount || 0);
                            totalWtxAmount += parseFloat(item.wtxAmount || 0);
                            // 验收数量
                            if (!Utils.isNoB(item.quantity) && item.quantity > 0) {
                                receiptQuantity += item.quantity;
                            }
                        }
                        purchReceipt.wtxAmount = amount.toFixed(2);
                        purchReceipt.receiptQuantity = receiptQuantity;
                    }
                    this.totalWtxAmount = parseFloat(totalWtxAmount.toFixed(2));
                    this.receiptList = Utils.merge([], purchReceipts);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        viewPurchReceipt: function (id) {
            let params = {
                id: id
            };
            openPurchReceiptTmpDetailDlg(null, params);
        },
        checkPhaseName: function (rule, value, callback) {
            if (Utils.isNoB(value)) {
                callback(new Error('请输入阶段名称'));
            } else if (value.length > 30) {
                callback(new Error('最多输入30个字,现有' + value.length + '个字'));
            } else {
                callback();
            }
        },
        changePhaseName: function (index) {
            let self = this;
            let row = self.settlePayPhaseInfo.settlePayPhaseList[index];
            let newPhaseName = row.phaseName;
            let _originalPhaseName = row._originalPhaseName;
            let rowFlag = row.rowFlag;

            // 如果名称未修改，直接返回
            if (newPhaseName === _originalPhaseName) {
                return;
            }

            // 检查名称是否唯一
            for (let i = 0; i < self.settlePayPhaseInfo.settlePayPhaseList.length; i++) {
                if (i !== index && self.settlePayPhaseInfo.settlePayPhaseList[i].rowFlag !== rowFlag && self.settlePayPhaseInfo.settlePayPhaseList[i].phaseName === newPhaseName) {
                    MsgBox.warning('阶段名称已存在');
                    // 恢复原来的名称
                    row.phaseName = _originalPhaseName;
                    return;
                }
            }

            // 更新原始名称
            for (let i = 0; i < self.settlePayPhaseInfo.settlePayPhaseList.length; i++) {
                if (self.settlePayPhaseInfo.settlePayPhaseList[i].rowFlag === rowFlag) {
                    self.settlePayPhaseInfo.settlePayPhaseList[i].phaseName = newPhaseName;
                    self.settlePayPhaseInfo.settlePayPhaseList[i]._originalPhaseName = newPhaseName;
                }
            }
        },
        changePhaseType(index) {
            let self = this;
            let row = self.settlePayPhaseInfo.settlePayPhaseList[index];
            for (let i = 0; i < self.settlePayPhaseInfo.settlePayPhaseList.length; i++) {
                if (i !== index && row.rowFlag === self.settlePayPhaseInfo.settlePayPhaseList[i].rowFlag) {
                    self.settlePayPhaseInfo.settlePayPhaseList[i].phaseType = row.phaseType;
                }
            }
            this.settlePayPhaseInfo.settlePayPhaseList = Utils.merge([], this.settlePayPhaseInfo.settlePayPhaseList);
        },
        changeAcntPeriodStartDate(index) {
            let self = this;
            let row = self.settlePayPhaseInfo.settlePayPhaseList[index];
            for (let i = 0; i < self.settlePayPhaseInfo.settlePayPhaseList.length; i++) {
                if (i !== index && row.rowFlag === self.settlePayPhaseInfo.settlePayPhaseList[i].rowFlag) {
                    self.settlePayPhaseInfo.settlePayPhaseList[i].acntPeriodStartDate = row.acntPeriodStartDate;
                }
            }
            this.settlePayPhaseInfo.settlePayPhaseList = Utils.merge([], this.settlePayPhaseInfo.settlePayPhaseList);
        },
        changeAcntPeriodDays(index) {
            let self = this;
            let row = self.settlePayPhaseInfo.settlePayPhaseList[index];
            for (let i = 0; i < self.settlePayPhaseInfo.settlePayPhaseList.length; i++) {
                if (i !== index && row.rowFlag === self.settlePayPhaseInfo.settlePayPhaseList[i].rowFlag) {
                    self.settlePayPhaseInfo.settlePayPhaseList[i].acntPeriodDays = row.acntPeriodDays;
                }
            }
            this.settlePayPhaseInfo.settlePayPhaseList = Utils.merge([], this.settlePayPhaseInfo.settlePayPhaseList);
        },
        changePhaseGapDays(index) {
            let self = this;
            let row = self.settlePayPhaseInfo.settlePayPhaseList[index];
            for (let i = 0; i < self.settlePayPhaseInfo.settlePayPhaseList.length; i++) {
                if (i !== index && row.rowFlag === self.settlePayPhaseInfo.settlePayPhaseList[i].rowFlag) {
                    self.settlePayPhaseInfo.settlePayPhaseList[i].phaseGapDays = row.phaseGapDays;
                }
            }
            this.settlePayPhaseInfo.settlePayPhaseList = Utils.merge([], this.settlePayPhaseInfo.settlePayPhaseList);
        },
        changeRatio() {
            let self = this;
            let settlePayPhaseList = this.settlePayPhaseInfo.settlePayPhaseList;
            let amountX = 0;
            let totalRatio = 0;
            for (let i = 0; i < settlePayPhaseList.length; i++) {
                if (!Utils.isNoB(settlePayPhaseList[i].ratio)) {
                    let amount = parseFloat((self.totalWtxAmount * (parseFloat(settlePayPhaseList[i].ratio) * 0.01)).toFixed(2));
                    settlePayPhaseList[i].amount = amount;
                    if (i < settlePayPhaseList.length - 1) {
                        amountX += amount;
                    }
                }
                totalRatio += parseFloat(settlePayPhaseList[i].ratio);
            }
            // 如果满100% 则最后一个用减法
            if (totalRatio === 100) {
                settlePayPhaseList[settlePayPhaseList.length - 1].amount = parseFloat((parseFloat(self.totalWtxAmount) - amountX).toFixed(2));
            }
            console.log(settlePayPhaseList);
        },
        payPhaseRemoveItem(index) {
            let settlePayPhaseList = this.settlePayPhaseInfo.settlePayPhaseList;
            let row = settlePayPhaseList[index];

            const firstRowIndex = settlePayPhaseList.findIndex(r => r.rowFlag === row.rowFlag);
            if (settlePayPhaseList[firstRowIndex].rowspan > 1) {
                // 如果行是合并的，减少 rowspan
                settlePayPhaseList[firstRowIndex].rowspan -= 1;

                // 如果删除的就是合并行的第一行，且还有合并行,则把nameRowspan、col2Rowspan给到下一行
                if (firstRowIndex == index && settlePayPhaseList[firstRowIndex].rowspan >= 1) {
                    settlePayPhaseList[firstRowIndex + 1].rowspan = settlePayPhaseList[firstRowIndex].rowspan;
                    settlePayPhaseList[firstRowIndex + 1].visible = true;
                }
            }
            // 删除当前行
            settlePayPhaseList.splice(index, 1);
            // 重新计算rowFlag
            let preRow = null;
            for (let i = 0; i < settlePayPhaseList.length; i++) {
                if (preRow == null) {
                    settlePayPhaseList[i].newRowFlag = 'row' + i;
                    preRow = settlePayPhaseList[i];
                } else if (preRow.rowFlag == settlePayPhaseList[i].rowFlag) {
                    settlePayPhaseList[i].newRowFlag = preRow.newRowFlag;
                } else {
                    settlePayPhaseList[i].newRowFlag = 'row' + i;
                    preRow = settlePayPhaseList[i];
                }
            }
            for (let i = 0; i < settlePayPhaseList.length; i++) {
                settlePayPhaseList[i].rowFlag = settlePayPhaseList[i].newRowFlag;
            }

            this.settlePayPhaseInfo.settlePayPhaseList = Utils.merge([], settlePayPhaseList);

            this.changeRatio();
        },
        addSettlePayPhase() {
            let settlePayPhaseList = this.settlePayPhaseInfo.settlePayPhaseList;
            if (settlePayPhaseList.length > 0 && settlePayPhaseList[settlePayPhaseList.length - 1].phaseType === 9) {
                return;
            }
            settlePayPhaseList.push({
                phaseName: null,
                phaseType: 1,
                calcBasis: 0,
                ratio: null,
                amount: null,
                acntPeriodStartDate: null,
                acntPeriodDays: null,
                phaseGapDays: null,
                payMethod: 1,
                rowspan: 1,
                visible: true,
                rowFlag: 'row' + settlePayPhaseList.length,
                _originalPhaseName: null
            });
            this.settlePayPhaseInfo.settlePayPhaseList = Utils.merge([], settlePayPhaseList);
        },
        addPhaseItem(index) {
            let currentRow = this.settlePayPhaseInfo.settlePayPhaseList[index];
            let newRow = {
                phaseName: currentRow.phaseName,
                phaseType: currentRow.phaseType,
                calcBasis: 0,
                ratio: null,
                amount: null,
                acntPeriodStartDate: currentRow.acntPeriodStartDate,
                acntPeriodDays: currentRow.acntPeriodDays,
                phaseGapDays: currentRow.phaseGapDays,
                payMethod: 1,
                rowspan: 1,
                visible: false,
                rowFlag: currentRow.rowFlag,
                _originalPhaseName: currentRow.phaseName
            };
            // 插入新行
            this.settlePayPhaseInfo.settlePayPhaseList.splice(index + 1, 0, newRow);
            // 更新当前行的 rowspan
            currentRow.rowspan += 1;
        },
        validateRatio: function (rule, value, callback) {
            if (Utils.isNoB(value)) {
                callback(new Error('请输入付款比例'));
            } else {
                if (!Utils.isMoneyStr(value) || parseFloat(value) < 0.01 || parseFloat(value) > 100) {
                    callback(new Error('请输入0.01~100的数字'));
                } else {
                    callback();
                }
            }
        },
        validateIntNotNull: function (rule, value, callback) {
            if (Utils.isNoB(value)) {
                callback(new Error('该属性不能为空'));
            } else {
                if (!Utils.isIntStr(value) || value <= 0) {
                    callback(new Error('请输入正整数'));
                } else {
                    callback();
                }
            }
        },
        getDlgResult: function () {
            let purchReceiptIds = this.purchReceiptList.pluck('id');
            //
            let result = {
                type: 'info'
            };
            if (!Utils.isNoB(this.memo) && this.memo.length > 250) {
                let result = {};
                result.type = 'warn';
                result.message = '结算描述最大长度不可超过250！';
                return result;
            }
            let settlePayPhaseList = Utils.merge([], this.settlePayPhaseInfo.settlePayPhaseList);
            if (!Utils.isNoB(settlePayPhaseList) && settlePayPhaseList.length > 0) {
                this.$refs['ruleForm'].validate(function (valid) {
                    if (valid) {
                        let totalRatio = 0;
                        for (let i = 0; i < settlePayPhaseList.length; i++) {
                            // 下一个项的账期起算日不能小于上一个
                            if (i > 0 && settlePayPhaseList[i].acntPeriodStartDate < settlePayPhaseList[i - 1].acntPeriodStartDate) {
                                result.type = 'warn';
                                result.message = '下一个阶段项的账期起算日不能小于上一个';
                                return result;
                            }
                            // 总比例不可大于100%
                            totalRatio += parseFloat(settlePayPhaseList[i].ratio);
                            // 不是最后一个阶段不可设置类型为尾款
                            if (settlePayPhaseList[i].rowFlag !== settlePayPhaseList[settlePayPhaseList.length - 1].rowFlag && settlePayPhaseList[i].phaseType === 9) {
                                result.type = 'warn';
                                result.message = '只有最后一个阶段才能设置阶段类型为尾款';
                                return result;
                            }
                            settlePayPhaseList[i].acntPeriodStartDate = settlePayPhaseList[i].acntPeriodStartDate.format('yyyy-MM-dd');
                            settlePayPhaseList[i].seqNo = i;
                        }
                        if (totalRatio > 100) {
                            result.type = 'warn';
                            result.message = '付款比例总和不能超过100%';
                            return result;
                        } else if (totalRatio < 100) {
                            result.message = '当前付款阶段比例不是100%，确认要继续操作吗？';
                        }
                        // 同阶段的支付方式不可重复
                        let dataX = {};
                        for (let i = 0; i < settlePayPhaseList.length; i++) {
                            if (dataX[settlePayPhaseList[i].rowFlag] == null) {
                                dataX[settlePayPhaseList[i].rowFlag] = [settlePayPhaseList[i]];
                            } else {
                                let listX = dataX[settlePayPhaseList[i].rowFlag];
                                // 循环listX
                                for (let j = 0; j < listX.length; j++) {
                                    if (listX[j].payMethod === settlePayPhaseList[i].payMethod) {
                                        result.type = 'warn';
                                        result.message = '同阶段的支付方式不可重复';
                                        return result;
                                    }
                                }
                                listX.push(settlePayPhaseList[i]);
                                dataX[settlePayPhaseList[i].rowFlag] = listX;
                            }
                        }
                    } else {
                        result.type = 'warn';
                        result.message = '校验失败';
                    }
                });
            }
            if (Utils.isNoB(result.message)) {
                result.message = '是否确认结算?';
            }
            // 转换为提交结构
            let settlePayPhaseListX = [];
            let settlePayPhaseMap = [];
            // 循环 settlePayPhaseList
            for (let i = 0; i < settlePayPhaseList.length; i++) {
                let settlePayPhaseItem = settlePayPhaseList[i];
                let settlePayItemCO = {};
                settlePayItemCO.phaseName = settlePayPhaseItem.phaseName;
                settlePayItemCO.calcBasis = settlePayPhaseItem.calcBasis;
                settlePayItemCO.ratio = settlePayPhaseItem.ratio;
                settlePayItemCO.amount = settlePayPhaseItem.amount;
                settlePayItemCO.payMethod = settlePayPhaseItem.payMethod;
                settlePayItemCO.seqNo = settlePayPhaseItem.seqNo;
                if(!settlePayPhaseMap[settlePayPhaseItem.phaseName]) {
                    settlePayPhaseMap[settlePayPhaseItem.phaseName] = [];
                    let phaseX = {};
                    phaseX.phaseType = settlePayPhaseItem.phaseType;
                    phaseX.phaseName = settlePayPhaseItem.phaseName;
                    phaseX.acntPeriodBasis = settlePayPhaseItem.acntPeriodBasis;
                    phaseX.acntPeriodStartDate = settlePayPhaseItem.acntPeriodStartDate;
                    phaseX.acntPeriodDays = settlePayPhaseItem.acntPeriodDays;
                    phaseX.phaseGapDays = settlePayPhaseItem.phaseGapDays;
                    settlePayPhaseListX.push(phaseX);
                }
                settlePayPhaseMap[settlePayPhaseItem.phaseName].push(settlePayItemCO);
            }
            for (let i = 0; i < settlePayPhaseListX.length; i++) {
                settlePayPhaseListX[i].settlePayItemList = settlePayPhaseMap[settlePayPhaseListX[i].phaseName];
                settlePayPhaseListX[i].seqNo = i;
            }
            let resultData = {
                ids: purchReceiptIds,
                autoApply: this.autoApply,
                autoAudit: this.autoAudit,
                memo: this.memo,
                acntPeriodForm: this.settlePayPhaseInfo.acntPeriodForm,
                settlePayPhaseList: settlePayPhaseListX
            };
            result.data = resultData;
            return result;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/receipt/SettleProofPurchReceiptTmp.vue